module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotRegistrationModal",
    attrs: {
      "id": "missionSlotRegistrationModal",
      "title": _vm.$t('mission.modal.slot.register'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotRegistrationModalData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.registerForMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.translatedModalText)
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.registration.comment.optional'),
      "description": _vm.$t('mission.registration.comment.description'),
      "state": "success"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "maxlength": "128"
    },
    model: {
      value: (_vm.missionSlotRegistrationData.comment),
      callback: function($$v) {
        _vm.missionSlotRegistrationData.comment = $$v
      },
      expression: "missionSlotRegistrationData.comment"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot registration actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.assignee ? true : false
    },
    on: {
      "click": _vm.registerForMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotRegistrationModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe8e48f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotRegistrationModal.vue
// module id = 494
// module chunks = 0